/** Runtime environment helpers — single source of truth for E2E/DEV guards. */

declare global {
  interface Window {
    __E2E_MODE__?: boolean;
    __E2E_SILENT__?: boolean;
    __E2E_SKIP_PROBE__?: boolean;
    __APP_VERSION__?: string;
    __retreatTestSchedule?: unknown;
    __retreatManager?: unknown;
    downloadTrace?: () => Promise<void>;
    downloadStory?: () => Promise<void>;
    printStory?: () => void;
    markStory?: (label: string) => void;
    removeStoryEntry?: (index: number) => void;
    clearStory?: () => void;
  }
}

export const isE2E = (): boolean =>
  typeof window !== "undefined" && window.__E2E_MODE__ === true;

export const isDevOrE2E = (): boolean =>
  import.meta.env.DEV || isE2E();

/** Returns the Playwright-injected test schedule, or null in production. */
export const getTestSchedule = <T = unknown>(): T | null =>
  isDevOrE2E() ? (window.__retreatTestSchedule as T) ?? null : null;

/** True when Playwright sets __E2E_SKIP_PROBE__ to keep the engine in IDLE. */
export const isE2ESkipProbe = (): boolean =>
  typeof window !== "undefined" && Boolean(window.__E2E_SKIP_PROBE__);

/** True when Playwright sets __E2E_SILENT__ to suppress audio during tests. */
export const isE2ESilent = (): boolean =>
  typeof window !== "undefined" && window.__E2E_SILENT__ === true;
export const getAppVersion = (): string | undefined =>
  typeof window !== 'undefined' ? window.__APP_VERSION__ : undefined;
